import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import useTingStore from '../../stores/tingStore';

export default function TingContentDetails() {
    const tingDoc = useTingStore(state => state.tingDoc);
    const setTingDoc = useTingStore(state => state.setTingDoc);

    const handleChange = (event) => {
        // Change value in setUserDoc based on what is typed
        setTingDoc({
            ...tingDoc,
            [event.target.id]: event.target.value
        });
    };

    return (
        <Box component="form" className="ting-editor__form">
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="contentType"
                        label="Content Type"
                        value={tingDoc?.contentType ?? ''}
                        onChange={handleChange}
                        variant="filled"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            readOnly: true,
                        }}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    {(tingDoc?.postImg || tingDoc?.postVideo) ? (
                        <div className="ting-editor__asset-links">
                            {tingDoc?.postImg && (
                                <Button
                                    variant="outlined"
                                    size="small"
                                    component="a"
                                    href={tingDoc.postImg}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Open Image
                                </Button>
                            )}
                            {tingDoc?.postVideo && (
                                <Button
                                    variant="outlined"
                                    size="small"
                                    component="a"
                                    href={tingDoc.postVideo}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Open Video
                                </Button>
                            )}
                        </div>
                    ) : (
                        <Typography variant="body2" className="ting-editor__empty-note">
                            No downloadable media is attached to this ting.
                        </Typography>
                    )}
                </Grid>
            </Grid>
        </Box>
    );
}
